import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { NODE_TYPE_COLORS } from '@/types/docflow';
import type { INodeConfig } from '@/types/docflow';

interface DriveInputNodeProps {
  data: {
    label: string;
    config: INodeConfig;
    selected?: boolean;
  };
}

const DriveInputNode = memo(({ data }: DriveInputNodeProps) => {
  const colors = NODE_TYPE_COLORS.drive_input;

  return (
    <div
      className={`px-4 py-3 rounded-lg border-2 shadow-md min-w-[180px] max-w-[220px] ${colors.bg} ${colors.border} ${
        data.selected ? 'ring-2 ring-blue-400' : ''
      }`}
    >
      <div className="flex items-center gap-2 mb-2">
        <svg className={`w-5 h-5 ${colors.text}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" />
        </svg>
        <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${colors.badge}`}>
          Drive Input
        </span>
      </div>

      <h4 className={`font-medium text-sm mb-1 ${colors.text}`}>
        {data.label}
      </h4>

      {data.config.folder_name && (
        <div className="text-xs text-gray-500 dark:text-gray-400 truncate">
          {data.config.folder_name}
        </div>
      )}

      {!data.config.folder_id && (
        <div className="text-xs text-gray-400 dark:text-gray-500 italic">
          No folder selected
        </div>
      )}

      <Handle
        type="source"
        position={Position.Right}
        className="w-3 h-3 !bg-blue-500"
      />
    </div>
  );
});

DriveInputNode.displayName = 'DriveInputNode';

export default DriveInputNode;
